import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-467">
      {label && <label htmlFor={inputId} className="block text-sm font-semibold text-white mb-2" data-id="element-468">
          {label}
        </label>}
      <input id={inputId} className={`w-full px-4 py-3 bg-dark-surface text-white border-2 border-dark-border rounded-industrial focus:outline-none focus:border-brand-yellow transition-colors ${error ? 'border-red-500' : ''} ${className}`} {...props} data-id="element-469" />
      {error && <p className="mt-1 text-sm text-red-500" role="alert" data-id="element-470">
          {error}
        </p>}
    </div>;
}